"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TW_OVERFLOW_ELLIPSIS = exports.tw = void 0;
const tw = (strings) => strings.join('');
exports.tw = tw;
exports.TW_OVERFLOW_ELLIPSIS = (0, exports.tw) `text-ellipsis overflow-x-hidden whitespace-nowrap`;
//# sourceMappingURL=tailwind.js.map